/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BaseGoodsForPackVo1 } from './BaseGoodsForPackVo1';
import {
    BaseGoodsForPackVo1FromJSON,
    BaseGoodsForPackVo1FromJSONTyped,
    BaseGoodsForPackVo1ToJSON,
    BaseGoodsForPackVo1ToJSONTyped,
} from './BaseGoodsForPackVo1';

/**
 * 
 * @export
 * @interface GoodsPackingLineVo
 */
export interface GoodsPackingLineVo {
    /**
     * 是否从条码历史预填体积；预填仍需点击体积保存
     * @type {boolean}
     * @memberof GoodsPackingLineVo
     */
    historyVolumePrefilled?: boolean;
    /**
     * 合包商品 id
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    id?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    code?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    marketProNm?: string;
    /**
     * 当前商品记录的可包装数量；快递件商品为实际拆分后的独立数量
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    quantity?: number;
    /**
     * 装箱数量（订单维度已装，与 getGoodsListForPack 一致）
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    packagedQuantity?: number;
    /**
     * 本箱该合包商品装箱数量（box_goods 按合包 id 汇总）
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    boxQuantity?: number;
    /**
     * 商品选项名
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    marketOptionName?: string;
    /**
     * 商品选项ID
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    marketOptionId?: string;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    marketBarcode?: string;
    /**
     * 商品重量 kg
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    weight?: number;
    /**
     * 商品长度
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    length?: number;
    /**
     * 商品宽度
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    width?: number;
    /**
     * 商品高度
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    height?: number;
    /**
     * 商品CBM
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    cbm?: number;
    /**
     * 商品单独包装费用
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    individuallyPackagedFee?: number;
    /**
     * 商品合包包装费用
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    combinedPackagedFee?: number;
    /**
     * 贴条码费用
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    barcodeFee?: number;
    /**
     * 原产地标费用
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    originMarkFee?: number;
    /**
     * 使用 OPP 袋费用
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    oppFee?: number;
    /**
     * 使用快递袋费用
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    courierBagFee?: number;
    /**
     * 商品是否可以原包装出库 0 不可以，1 可以
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    originPackageOutbound?: number;
    /**
     * 商品来源，见 GoodsSourceTypeEnum
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    sourceType?: number;
    /**
     * SKU id
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    skuId?: number;
    /**
     * SKU 编码
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    skuCode?: string;
    /**
     * 原产地
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    origin?: string;
    /**
     * 是否打印原产地标 0 不打印，1 打印
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    originPrint?: number;
    /**
     * 原产地标作业方式，存客户下单编码或手填原文
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    originJob?: string;
    /**
     * 原产地标作业方式展示名，按当前语言翻译枚举，手填原文原样返回
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    originJobName?: string;
    /**
     * 是否为火箭订单拆出的快递件商品：0 否，1 是
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    simple?: number;
    /**
     * 是否合包商品：0 否，1 是
     * @type {number}
     * @memberof GoodsPackingLineVo
     */
    combined?: number;
    /**
     * 合包包装作业备注，仅合包商品有值
     * @type {string}
     * @memberof GoodsPackingLineVo
     */
    combinedPackingRemark?: string;
    /**
     * 合包商品下的基础商品列表
     * @type {Array<BaseGoodsForPackVo1>}
     * @memberof GoodsPackingLineVo
     */
    baseGoodsForPackVOList?: Array<BaseGoodsForPackVo1>;
}

/**
 * Check if a given object implements the GoodsPackingLineVo interface.
 */
export function instanceOfGoodsPackingLineVo(value: object): value is GoodsPackingLineVo {
    return true;
}

export function GoodsPackingLineVoFromJSON(json: any): GoodsPackingLineVo {
    return GoodsPackingLineVoFromJSONTyped(json, false);
}

export function GoodsPackingLineVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsPackingLineVo {
    if (json == null) {
        return json;
    }
    return {
        
        'historyVolumePrefilled': json['historyVolumePrefilled'] == null ? undefined : json['historyVolumePrefilled'],
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'packagedQuantity': json['packagedQuantity'] == null ? undefined : json['packagedQuantity'],
        'boxQuantity': json['boxQuantity'] == null ? undefined : json['boxQuantity'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'individuallyPackagedFee': json['individuallyPackagedFee'] == null ? undefined : json['individuallyPackagedFee'],
        'combinedPackagedFee': json['combinedPackagedFee'] == null ? undefined : json['combinedPackagedFee'],
        'barcodeFee': json['barcodeFee'] == null ? undefined : json['barcodeFee'],
        'originMarkFee': json['originMarkFee'] == null ? undefined : json['originMarkFee'],
        'oppFee': json['oppFee'] == null ? undefined : json['oppFee'],
        'courierBagFee': json['courierBagFee'] == null ? undefined : json['courierBagFee'],
        'originPackageOutbound': json['originPackageOutbound'] == null ? undefined : json['originPackageOutbound'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'originPrint': json['originPrint'] == null ? undefined : json['originPrint'],
        'originJob': json['originJob'] == null ? undefined : json['originJob'],
        'originJobName': json['originJobName'] == null ? undefined : json['originJobName'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'combinedPackingRemark': json['combinedPackingRemark'] == null ? undefined : json['combinedPackingRemark'],
        'baseGoodsForPackVOList': json['baseGoodsForPackVOList'] == null ? undefined : ((json['baseGoodsForPackVOList'] as Array<any>).map(BaseGoodsForPackVo1FromJSON)),
    };
}

export function GoodsPackingLineVoToJSON(json: any): GoodsPackingLineVo {
    return GoodsPackingLineVoToJSONTyped(json, false);
}

export function GoodsPackingLineVoToJSONTyped(value?: GoodsPackingLineVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'historyVolumePrefilled': value['historyVolumePrefilled'],
        'id': value['id'],
        'code': value['code'],
        'marketProNm': value['marketProNm'],
        'quantity': value['quantity'],
        'packagedQuantity': value['packagedQuantity'],
        'boxQuantity': value['boxQuantity'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcode': value['marketBarcode'],
        'weight': value['weight'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
        'individuallyPackagedFee': value['individuallyPackagedFee'],
        'combinedPackagedFee': value['combinedPackagedFee'],
        'barcodeFee': value['barcodeFee'],
        'originMarkFee': value['originMarkFee'],
        'oppFee': value['oppFee'],
        'courierBagFee': value['courierBagFee'],
        'originPackageOutbound': value['originPackageOutbound'],
        'sourceType': value['sourceType'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'origin': value['origin'],
        'originPrint': value['originPrint'],
        'originJob': value['originJob'],
        'originJobName': value['originJobName'],
        'simple': value['simple'],
        'combined': value['combined'],
        'combinedPackingRemark': value['combinedPackingRemark'],
        'baseGoodsForPackVOList': value['baseGoodsForPackVOList'] == null ? undefined : ((value['baseGoodsForPackVOList'] as Array<any>).map(BaseGoodsForPackVo1ToJSON)),
    };
}

